export const SET_DEVICE = 'SET_DEVICE'
export const SET_DEVICES = 'SET_DEVICES'



// WEBPACK FOOTER //
// ./src/store/modules/admin/types.js